"use client";

import { Card, CardContent } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { MapPin } from "lucide-react";
import { ServiceLocation as Location } from "@/types/service";

interface ServiceLocationProps {
  locations: Location[];
  selectedLocation: Location;
  onSelect: (location: Location) => void;
}

export function ServiceLocation({ locations, selectedLocation, onSelect }: ServiceLocationProps) {
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <MapPin className="w-5 h-5 text-muted-foreground" />
            <h2 className="text-lg font-semibold">Select Location</h2>
          </div>
          <RadioGroup
            value={selectedLocation.name}
            onValueChange={(value) => {
              const location = locations.find((l) => l.name === value);
              if (location) onSelect(location);
            }}
          >
            <div className="grid gap-4">
              {locations.map((location) => (
                <div key={location.name} className="flex items-center space-x-4">
                  <RadioGroupItem value={location.name} id={location.name} />
                  <Label htmlFor={location.name} className="flex-1">
                    <div className="font-medium">{location.name}</div>
                    <div className="text-sm text-muted-foreground">
                      {location.address}, {location.city}, {location.state} {location.zip_code}
                    </div>
                  </Label>
                </div>
              ))}
            </div>
          </RadioGroup>
        </div>
      </CardContent>
    </Card>
  );
}